Ext.define('SA.controller.ScarboroughCrosstabController', {
    extend: 'SA.ViewController',

    statics: {
        getSupportedTabs(model) {
            var predicates = {locations: model.canSelectLocation(), data: model.canAddAttributes()};

            return ['locations', 'data'].filter(tab => predicates[tab]);
        }
    },

    constructor() {
        this.callParent(arguments);

        this.mon(SA.AppController, 'switch:projectView', this.syncFromModel, this);
        this.mon(this.model.getProject(), 'change:attribute', this.syncFromModel, this);
        this.mon(this.model, 'change:attribute', this.syncFromModel, this);
        this.mon(this.model, 'change:location', this.onLocationChange, this);
    },

    createDefaultView() {
        this.toolbar = new SA.view.CrosstabToolbar({model: this.model});

        this.toolbar.on('activate:exportBtn', this.onActivateExportBtn, this);

        return SA.ProjectView.createHidden({xtype: 'crosstab-view', projectView: this.model});
    },

    createEditView() {
        this.editController = new SA.ScarboroughCrosstabEditController(this.getEditControllerParams());

        return SA.ProjectView.createHidden(this.editController.getView());
    },

    getTableController() {
        var params = {model: this.model, toolbar: this.toolbar, view: this.projectViews.getViewModeItem()},
            controller = this.tableController = (this.tableController || new SA.CrosstabTableController(params));

        return controller;
    },

    onActivateExportBtn(toolbarButton) {
        var config = new SA.CrosstabExportConfig({model: this.model});

        Ext.widget({xtype: 'arrow-export-menu', config, toolbarButton});
    },

    onActive() {
        var supportedTabs = SA.controller.ScarboroughCrosstabController.getSupportedTabs(this.model),
            selectedTab = supportedTabs.length === 1 ? supportedTabs[0] : (SA.Sidebar.lastClickedLocationsTab() ? 'locations' : 'data');

        SA.SidebarState.create()
            .enableTabs(supportedTabs)
            .selectTab(selectedTab)
            .setTabMouseOverListener(tab => this.onSidebarTabMouseOver(tab))
            .setModel(this.model)
            .apply();
    },

    onLocationChange() {
        Ext.destroyMembers(this, 'tableController');
        this.projectViews.destroyViewMode();

        this.syncFromModel();
    },

    onSidebarTabMouseOver(tab) {
        if (tab.isEnabled() || !tab.hasType('locations')) {
            return;
        }

        var tooltipContent = [
            'A Scarborough Crosstab Table can only have one location. You can create a new Scarborough Crosstab view ',
            'and select a different location for this view.'
        ].join('');

        new SA.Tooltip({target: tab.getDom(), content: tooltipContent});
    },

    refreshModeIndicator() {
        var text = `Scarborough Crosstab Data & Locations: ${this.model.getYear()}`;

        if (this.model.hasLatestYear()) {
            text += ' (Latest)';
        }

        SA.ModeIndicator.set({text, visible: true});
    },

    syncFromModel() {
        if (!this.isActive() || this.isEditMode()) {
            return;
        }

        this.getTableController().syncFromModel();
    }
});